/*
 * @Author: jiangzhengjie
 * @Date: 2023-09-02 20:29:38
 * @LastEditors: jiangzhengjie jiangzhengjie@didiglobal.com
 * @LastEditTime: 2023-09-08 00:30:16
 * @FilePath: /train-service/src/pages/make-order/components/ticketing-notice-drawer.mpx
 * @Description: type0为填单购票通知弹窗 提示不在12306服务时段并有免登入口
       type1为填单购票提示弹窗 提示乘车人信息不完整并展示名单
 * 不想写bug
 */
<template  minapp='mpx' xlang='wxml'>
  <controllable-drawer-bottom
    title="购票提示"
    show="{{show}}"
    bind:close="closeNoticeDrawer"
  >
    <view class="card" wx:class="{{noticeType && 'prompt'}}">
      <view class="card-notice">{{ noticeText }}</view>
      <view class="notice-description" wx:class="{{noticeType && 'prompt'}}">{{
        noticeDescription
      }}</view>
      <buy-ticket-card
        wx:if="{{noticeType === 0}}"
        buttonType="{{1}}"
        isDrawer="{{true}}"
        from="{{from}}"
        drawerPrice="{{drawerPrice}}"
        bind:check="check"
        bind:close="closeNoticeDrawer"
        bind:getServiceDescription="getServiceDescription"
      />
      <view wx:else class="prompt-card-main">
        <view class="contact-group">
          <view class="contact-item" wx:for="{{contactList}}" wx:key="index">
            <svg
              class="contact-icon"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="none"
              version="1.1"
              width="12"
              height="14"
              viewBox="0 0 27 28"
            >
              <g>
                <g>
                  <ellipse
                    cx="13.5"
                    cy="9"
                    rx="7.5"
                    ry="7.5"
                    fill-opacity="0"
                    stroke-opacity="1"
                    stroke="#222222"
                    fill="none"
                    stroke-width="3"
                  />
                </g>
                <g>
                  <path
                    d="M1.076426,22.86691Q0,25.24567,0,28L3,28Q3,23.80043,6.00874,21.13807Q8.99003,18.5,13.5,18.5Q18.01,18.5,20.9913,21.13807Q24,23.80043,24,28L27,28Q27,25.24567,25.9236,22.86691Q24.8894,20.5816,22.9793,18.89137Q21.1245,17.250091,18.6761,16.37439Q16.2314,15.5,13.5,15.5Q10.76863,15.5,8.3239,16.374389Q5.8755,17.250092,4.02069,18.89137Q2.110558,20.5816,1.076426,22.86691Z"
                    fill-rule="evenodd"
                    fill="#222222"
                    fill-opacity="1"
                  />
                </g>
              </g>
            </svg>
            <view class="contact-name">
              {{ item.passenger_name }}
            </view>
          </view>
        </view>
        <view class="prompt-button" bindtap="addPassenger">完善信息</view>
      </view>
    </view>
  </controllable-drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { DeadLineList } from '@/utils/constants'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false,
      },
      noticeType: {
        type: Number,
        value: 0,
      },
      contactList: {
        type: Array,
        value: () => [],
      },
      drawerPrice: {
        type: Number,
        value: 0,
      }
    },
    attached() {},
    computed: {
      from() {
        return this.$mpxRoute?.query?.from || ''
      },
      noticeText() {
        return this.noticeType === 0 ? '12306不在服务时段' : '乘车人信息不完整'
      },
      noticeDescription() {
        return this.noticeType === 0
          ? '铁路12306每日5:00至次日1:00（周二为5:00至23:30)\n提供购票、改签、变更到站业务办理'
          : '以下乘车人信息需要重新添加，请注意核对'
      },
    },
    data: {},
    methods: {
      closeNoticeDrawer() {
        this.triggerEvent('close')
      },
      check() {
        this.closeNoticeDrawer()
        this.triggerEvent('check')
      },
      addPassenger() {
        this.closeNoticeDrawer()
        this.triggerEvent('addPassenger')
      },
      getServiceDescription() {
        this.triggerEvent('getServiceDescription')
      },
    },
  })
</script>

<style lang='stylus' scoped>
  .card
    margin-top 24px
    display flex
    flex-direction column
    padding 0 20px 49px 20px
    &.prompt
      padding-bottom 39px
    &-notice
      font-family PingFangSC-Medium
      font-size 18px
      line-height 18px
      color #000
      margin-bottom 5px
    .notice-description
      font-family PingFangSC-Regular
      font-size 12px
      line-height 18px
      color #999
      margin-bottom 23px
      white-space pre-wrap
      &.prompt
        margin-bottom 16px
    .prompt-card-main
      display flex
      flex-direction column
      overflow-x hidden
      .contact-group
        display flex
        flex-direction row
        flex-wrap wrap
        margin-bottom 26px
        .contact-item
          display flex
          height 40px
          align-items center
          padding 0 16px
          margin-right 8px
          margin-bottom 8px
          border-radius 10px
          background #f6f9fd
          font-family PingFangSC-Medium
          font-size 16px
          line-height 16px
          color #333
          .contact-icon
            margin-right 8px
      .prompt-button
        padding 14.5px 0
        display flex
        justify-content center
        border-radius 10px
        color #fff
        background #FF6400
        line-height 15px
        font-family PingFangSC-Medium
      font-size 15px
</style>

  
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'controllable-drawer-bottom': '@/components/controllable-drawer-buttom',
      'login-drawer-button': './login-drawer-button',
      'buy-ticket-card': '@/pages/train-detail/components/buy-ticket-card',
    },
  }
</script>